// Demo coachmarks. Any element with a `data-demo-hint` attribute pulses (CSS)
// and shows a hint on hover/focus. The attribute is only rendered in demo mode
// (templates gate it with {% if is_in_demo_mode %}), so if none are present this
// no-ops.
//
//   <a ... data-demo-hint="Help text"
//          data-demo-hint-title="Optional bold lead"
//          data-demo-hint-pos="top|bottom|left|right">
//
// A single tooltip element is appended to <body> and positioned against the
// target with getBoundingClientRect, flipping to stay on-screen — so it never
// clips inside scroll/overflow containers (e.g. the gradebook table).

;(() => {
  const GAP = 10
  let tip
  let current = null

  function buildTip() {
    tip = document.createElement('div')
    tip.className = 'demo-hint__tip'
    tip.setAttribute('role', 'tooltip')
    document.body.appendChild(tip)
  }

  function render(el) {
    tip.textContent = ''
    const title = el.dataset.demoHintTitle
    if (title) {
      const strong = document.createElement('strong')
      strong.textContent = title
      tip.appendChild(strong)
    }
    tip.appendChild(document.createTextNode(el.dataset.demoHint || ''))
  }

  function position(el) {
    const r = el.getBoundingClientRect()
    const tw = tip.offsetWidth
    const th = tip.offsetHeight
    const vw = document.documentElement.clientWidth
    const vh = document.documentElement.clientHeight
    const pos = el.dataset.demoHintPos || 'bottom'

    let top
    let left
    if (pos === 'top') {
      top = r.top - th - GAP
      left = r.left
    } else if (pos === 'left') {
      top = r.top
      left = r.left - tw - GAP
    } else if (pos === 'right') {
      top = r.top
      left = r.right + GAP
    } else {
      top = r.bottom + GAP
      left = r.left
    }

    // Flip / clamp to keep it on-screen.
    if (top + th > vh - 4) top = r.top - th - GAP
    if (top < 4) top = r.bottom + GAP
    if (left + tw > vw - 4) left = vw - tw - 4
    if (left < 4) left = 4

    tip.style.top = `${top}px`
    tip.style.left = `${left}px`
  }

  function show(el) {
    current = el
    render(el)
    tip.classList.add('is-visible')
    position(el)
  }

  function hide() {
    current = null
    tip.classList.remove('is-visible')
  }

  function init() {
    const els = document.querySelectorAll('[data-demo-hint]')
    if (!els.length) return // not in demo mode -> nothing to wire up
    buildTip()
    els.forEach((el) => {
      el.addEventListener('mouseenter', () => show(el))
      el.addEventListener('mouseleave', hide)
      el.addEventListener('focusin', () => show(el))
      el.addEventListener('focusout', hide)
    })
    window.addEventListener('scroll', () => current && position(current), true)
    window.addEventListener('resize', () => current && position(current))
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
